/* eslint-disable */
import React from 'react';
import {toast} from 'react-toastify';
import ToastMessage from '../components/common/toast-message';
import irelandApi from '../irelandApi';
import {
  GET_LATEST_NEWS_PENDING,
  GET_LATEST_NEWS_FULFILLED,
  GET_LATEST_NEWS_REJECTED,
  GET_RDR_FULFILLED,
  GET_RDR_PENDING,
  GET_RDR_REJECTED,
  GET_RETAILER_FULFILLED,
  GET_RETAILER_PENDING,
  GET_RETAILER_REJECTED
} from '../reducers/latestNewsReducer';
import {history} from "../store";


export const getLatestNews = () => (dispatch) => {
  dispatch({
    type: GET_LATEST_NEWS_PENDING,
    payload: []
  });

  return irelandApi.get('/api/articles?location=website')
    .then((response) => {
      dispatch({
        type: GET_LATEST_NEWS_FULFILLED,
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_LATEST_NEWS_REJECTED,
        payLoad: error
      });
      toast.error(<ToastMessage iconStyle="success" message="You don't have permission to view this page"/>);
      history.push('/');
    });
};


export const getRDRNews = () => (dispatch) => {
  dispatch({
    type: GET_RDR_PENDING,
    payload: []
  });

  return irelandApi.get(`/api/articles_rep?location=website`)
    .then((response) => {
      dispatch({
        type: GET_RDR_FULFILLED,
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_RDR_REJECTED,
        payLoad: error
      });
    });
};


export const getRetailerNews = () => (dispatch) => {
  dispatch({
    type: GET_RETAILER_PENDING,
    payload: []
  });

  return irelandApi.get(`/api/articles_retailer?location=website`)
    .then((response) => {
      dispatch({
        type: GET_RETAILER_FULFILLED,
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_RETAILER_REJECTED,
        payLoad: error
      });
    });
};



// WEBPACK FOOTER //
// ./src/actions/latest-news.js